import { Stack, Typography, useMediaQuery, useTheme } from '@mui/material';
import InfoIcon from 'assets/img/icons/InfoIcon';
import { useEffect, useState } from 'react';
import { DotComponent } from './components/DotComponent';

export interface LoadingProps {
  labels: string[];
}

const Loading = (props: LoadingProps) => {
  const { labels } = props;
  const [currentLabel, setCurrentLabel] = useState(labels[0]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const theme = useTheme();

  const isMobileScreen = useMediaQuery(theme.breakpoints.down('tablet'));

  useEffect(() => {
    const timer = setTimeout(() => {
      setCurrentIndex((prevIndex) => {
        const nextIndex = prevIndex + 1;
        if (nextIndex < labels.length) {
          setCurrentLabel(labels[nextIndex]);
          return nextIndex;
        } else {
          clearInterval(timer);
          return prevIndex;
        }
      });
    }, 4000);

    return () => clearInterval(timer);
  }, [labels, currentIndex]);

  const dots = [0, 0.5, 1];

  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      <InfoIcon
        width={isMobileScreen ? '14' : '19'}
        height={isMobileScreen ? '14' : '19'}
        // sx={{
        //   display: 'flex',
        //   alignItems: 'center',
        //   mt: { desktop: '4px', tablet: '4px', mobile: '4px' },
        // }}
      />
      <Typography
        color="gray"
        sx={{
          fontSize: { desktop: '16px', tablet: '16px', mobile: '13px' },
          mt: { desktop: '4px', tablet: '4px', mobile: 0 },
        }}
      >
        {currentLabel}
      </Typography>
      {!isMobileScreen && (
        <Stack flexDirection="row" gap={0.5} ml="16px" mt="14px">
          {dots.map((dot, key) => {
            return <DotComponent key={key} animationTime={dot} />;
          })}
        </Stack>
      )}
    </Stack>
  );
};

export default Loading;
